var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuitcaseBlackShape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      enableBackground: "new 0 0 563.957 563.957"
    },
    xmlSpace: "preserve",
    viewBox: "0 0 563.957 563.957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M198.337 417.882h167.278v32.639H198.337zM544.875 148.933H390.102V75.009c0-10.141-8.219-18.36-18.361-18.36H192.217c-10.141 0-18.36 8.219-18.36 18.36v73.917H19.082C8.543 148.927 0 157.47 0 168.009V398.5h563.957V168.015c0-10.538-8.543-19.082-19.082-19.082zm-309.818-31.084h93.837v31.078h-93.837v-31.078z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M383.98 417.882v32.639c0 10.141-8.219 18.359-18.359 18.359H198.337c-10.141 0-18.36-8.219-18.36-18.359v-32.639c0-.349.085-.673.104-1.021H0v71.365c0 10.539 8.543 19.082 19.082 19.082h525.793c10.539 0 19.082-8.543 19.082-19.082V416.86h-180.08c.018.343.103.673.103 1.022z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcaseBlackShape);
export default __webpack_public_path__ + "static/media/suitcase-black-shape.ec096a5a.svg";
export { ForwardRef as ReactComponent };